import React, { FC } from 'react';
import { SelectArrayInput as RaSelectArrayInput } from 'react-admin';

const SelectArrayInput: FC<any> = (props) => {
  return (
    <RaSelectArrayInput
      options={{
        MenuProps: {
          variant: 'menu',
          getContentAnchorEl: null,
        },
      }}
      {...props}
    />
  );
};

export default SelectArrayInput;
